export const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export type UTM_PARAM_NAMES = typeof UTM_PARAMS[number];

export const getUtmParams = (
  url: string | URL
): Partial<Record<UTM_PARAM_NAMES, string>> | null => {
  if (!url) {
    return null;
  }
  const urlObj = url instanceof URL ? url : new URL(url);
  return getUtmParamsFromSearch(urlObj.searchParams);
};

export const getUtmParamsFromSearch = (
  params: URLSearchParams
): Partial<Record<UTM_PARAM_NAMES, string>> | null => {
  const utmParams: Partial<Record<UTM_PARAM_NAMES, string>> = {};
  params.forEach((value, key) => {
    if (UTM_PARAMS.includes(key as UTM_PARAM_NAMES)) {
      utmParams[key as UTM_PARAM_NAMES] = value;
    }
  });
  if (Object.keys(utmParams).length === 0) {
    return null;
  }
  return utmParams;
};
